"use strict";
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWorkerEnvironment = exports.globalObject = void 0;
exports.getGlobalObject = getGlobalObject;
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get() {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    let globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
/**
 * Cached reference to the global object so it can be imported and re-used without
 * re-evaluating the heavyweight fallback logic in `getGlobalObject()`.
 */
// eslint-disable-next-line local-rules/disallow-side-effects
exports.globalObject = getGlobalObject();
exports.isWorkerEnvironment = 'WorkerGlobalScope' in exports.globalObject;
//# sourceMappingURL=globalObject.js.map